export default __webpack_public_path__ + "static/media/Realtime.e6b98e3e.png";